import { atomWithReset as stateSegmentWithReset } from 'jotai/utils';
import { CannedParams } from '../../../types/Content';

export const actionsSegment = stateSegmentWithReset<CannedParams[]>([]);

actionsSegment.debugLabel = 'actionsSegment';
